import {React} from 'react';
import {Button} from 'react-bootstrap';
import Header from './common/Header';


function Notfound(){
   
    return(
      <>
      <Header/>
        <div id='not_found_cntn'>
          <img src="/404_error.jpg" alt="not found"/>
        </div>
        <div className="d-flex flex-column align-items-center mb-2"><Button variant="light" onClick={()=>window.location.assign('/home')}>Go to Homepage</Button> </div>
        
        
        </>
    )
}

export default Notfound;